import axios from 'axios'
import { Message } from 'view-design'
import { getToken, removeToken } from '@/store/cookies'
import route from '@/router'
import {
    getUSERINFO
} from '../store/cookies'
// import requestProperties from '@/utils/requestProperties.js'

// create an axios instance

const service = axios.create({
    baseURL: process.env.VUE_APP_BASEURL, // api 的 base_url
    timeout: 300000 // 超时时间
})
// request interceptor
service.interceptors.request.use(
    (config) => {
        config.headers['Content-Type'] = 'application/json; charset=UTF-8'
        if (getToken())
            config.headers['Authorization'] = `Bearer ${getToken()}`
        try {
            const temp = JSON.parse(getUSERINFO())
            config.headers['user_id'] = temp.vUserId
        } catch (error) {
            config.headers['user_id'] = config.data ? config.data.userName || '' : ''
        }

        config.data
        return config
    },
    (error) => {
        console.log(error) // for debug
        Promise.reject(error)
    }
)
// response interceptor
service.interceptors.response.use((response) => {
            const res = response.data
            if (res.code == '0000')
                return response
            else {
                if (res.code && res.code === '1111' || res.code && res.code === '0001') {
                    Message.error({
                        content: res.message,
                        duration: 5
                    })
                    return Promise.reject(response)
                } else {
                    if (res.message && res.code != 200) {
                        Message.error({
                            content: res.message,
                            duration: 5
                        })
                    }
                    return response
                }
            }
        },
        (error) => {
            const status = error.response.status
            if (status === 401) {
                route.push('/login')
                return
            }
            Message.error({
                content: '请求失败，请等待60秒后重试！',
                duration: 5
            })
            return Promise.reject(error)

        }),

    function getNowFormatDate() {
        var date = new Date()
        var seperator1 = '-'
        var seperator2 = ':'
        var month = date.getMonth() + 1
        var strDate = date.getDate()
        var Hours = date.getHours()
        var Seconds = date.getSeconds()
        var Minutes = date.getMinutes()
        if (month >= 1 && month <= 9) {
            month = '0' + month
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = '0' + strDate
        }
        if (Hours >= 0 && Hours <= 9) {
            Hours = '0' + Hours
        }
        if (Minutes >= 0 && Minutes <= 9) {
            Minutes = '0' + Minutes
        }
        if (Seconds >= 0 && Seconds <= 9) {
            Seconds = '0' + Seconds
        }
        var currentdate = `${date.getFullYear()}${seperator1}${month}${seperator1}${strDate}T${Hours}${seperator2}${Minutes}${seperator2}${Seconds}Z`
        return currentdate
    }

export default service